
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Video, MessageSquare } from "lucide-react";
import { Interview } from "@/types/interview";

interface InterviewActionsProps {
  interview: Interview;
  onAccept: (id: string) => void;
  onCancel: (id: string) => void;
  onJoin: (interview: Interview) => void;
}

export const InterviewActions = ({ 
  interview, 
  onAccept, 
  onCancel, 
  onJoin 
}: InterviewActionsProps) => {
  if (interview.status === "pending") {
    return (
      <div className="flex gap-3">
        <Button
          variant="outline"
          className="border-emerald-200 text-emerald-600 hover:bg-emerald-50 interactive-hover"
          onClick={() => onAccept(interview.id)}
        >
          <CheckCircle2 className="w-4 h-4 mr-2" />
          Accept
        </Button>
        <Button
          variant="outline"
          className="border-red-200 text-red-600 hover:bg-red-50 interactive-hover"
          onClick={() => onCancel(interview.id)}
        >
          <XCircle className="w-4 h-4 mr-2" />
          Cancel
        </Button>
      </div>
    );
  }

  if (interview.status === "accepted") {
    return (
      <Button 
        className="bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600 interactive-hover"
        onClick={() => onJoin(interview)}
      >
        {interview.type === "video" ? (
          <Video className="w-4 h-4 mr-2" />
        ) : (
          <MessageSquare className="w-4 h-4 mr-2" />
        )}
        Join Meeting
      </Button>
    );
  }

  return null;
};
